<template>
  <div class="overflow-auto">
    <table
      v-if="categories.length > 0"
      class="table table-hover table-bordered"
      style="width:auto">
      <thead>
      <th>&nbsp;</th>
      <th><small>ед.</small></th>

      <th
        v-for="date in dates"
        :key="date"
        class="px-1 text-center">
        <small class="">{{ date }} </small>
      </th>
      </thead>

      <tbody
        v-for="category in categories"
        :key="category.categoryId">
      <tr>
        <th :colspan="dates.length + 2">
          {{ category.categoryName }}
        </th>
      </tr>
      <tr
        v-for="test in category.tests"
        :key="test.testId">
        <td width="400" style="width: 400px !important;" class="text-nowrap py-0">
          <div class="py-2">{{ test.testName }}</div>
        </td>
        <td width="40" style="width:40px !important;" class="text-nowrap py-0">
          <div class="py-2">{{ test.testMeasure }}</div>
        </td>

        <td
          v-for="date in dates"
          :key="category.categoryId + '-' + test.testId + '-' + date"
          class="p-0">
          <div
            v-for="result in test.results"
            :key="category.categoryId + '-' + test.testId + '-' + date + '-' + result.id"
            @click="$emit('update-result', result.id)"
            style="cursor:pointer;">
            <div
              v-if="result.dateFormatted === date"
              :class="'py-2 text-center tests-result-status tests-result-status-' + result.status">
              {{ result.value }}
            </div>
          </div>
        </td>
      </tr>

      </tbody>
    </table>
  </div>
</template>

<script>
import formatDate from '../../../utils/formatDate';

export default {
  name: 'ClientTestCalendar',

  props: ['client', 'results'],

  computed: {
    dates() {
      const dates = [];

      for (const result of this.results) {
        const date = formatDate(result.date, 'd.m.y');

        if (dates.includes(date) === false) {
          dates.push(date);
        }
      }

      dates.sort((a, b) => {
        const [ad, am, ay] = a.split('.');
        const [bd, bm, by] = b.split('.');

        return parseInt(`${ay}${am}${ad}`) - parseInt(`${by}${bm}${bd}`);
      });

      return dates;
    },

    categories() {
      const categories = [];

      for (const result of this.results) {
        const dateFormatted = formatDate(result.date, 'd.m.y');

        let category = categories.find(category => {
          return category.categoryId === result.categoryId;
        });

        if (typeof category === 'undefined') {
          category = {
            categoryId: result.categoryId,
            categoryName: result.categoryName,
            tests: [],
          };

          categories.push(category);
        }

        let test = category.tests.find(test => {
          return test.testId === result.testId;
        });

        if (typeof test === 'undefined') {
          test = {
            testId: result.testId,
            testName: result.testName,
            testMeasure: result.testMeasure,
            testReference: result.testReference,
            results: [],
          };

          category.tests.push(test);
        }

        test.results.push(Object.assign({dateFormatted}, result));
      }

      categories.sort((a, b) => a.sort - b.sort);

      for (const category of categories) {
        category.tests.sort((a, b) => a.sort - b.sort);
      }

      return categories;
    },
  },
};
</script>
